export default __webpack_public_path__ + "static/media/back.2a7692a2.svg";